import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import MainShop from "./MainShop";
import { apiClient } from "../../services/apiClientService";

/**
 * Multi-vendor: show marketing landing at `/`.
 * Single-vendor (superuser vendor set): open product list (`/shop`) by default.
 */
const SingleVendorRoot = () => {
  const [singleVendor, setSingleVendor] = useState(null); // null = checking

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await apiClient("GET", "/api/vendors/storefront", null, {
          skipLoading: true,
        });
        if (!alive) return;
        setSingleVendor(!!res?.singleVendor);
      } catch {
        if (!alive) return;
        setSingleVendor(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  if (singleVendor === null) {
    return (
      <div className="flex justify-center items-center min-h-[40vh]">
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-pink-500 border-t-transparent" />
      </div>
    );
  }

  if (singleVendor) {
    return <Navigate to="/shop" replace />;
  }

  return <MainShop />;
};

export default SingleVendorRoot;
